import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, OocyteQualityAssessmentByCodeController, OocyteQualityAssessmentByCodeRequest, CycleOocyteQualityBetweenDateController, CycleOocyteQualityBetweenDateRequest, IvfOocyteEmbryoStorageByCodeController, IvfOocyteEmbryoStorageByCodeRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { OocyteStoreItem } from '../../../testnurse/ivf/ivfworkbench/ivfoqaedit.component';




@Component({
  selector: 'oocytequality',
  templateUrl: './oocytequality.component.html',
  styleUrls: ['./oocytequality.component.scss']
})

export class OocytequalityPVComponent implements OnInit {

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;

  public OQACode: any;
  public Owner: string;
  public PatientId: string;
  public ProtocolStart: string;
  public ProtocolEnd: string;
  public Protocol: string;
  public Infertility: string;
  public Gender: string;
  public Age: string;
  public CycleNo: string;
  public CycleType: string;
  public TransferedCount: number;
  public FrozenCount: number;
  public DiscardedCount: number;
  public TotalCount: number;
  public AggregatedCount: number;
  public AZPCount: number;
  public CGMCount: number;
  public EGMCount: number;
  public FPBCount: number;
  public FragileCount: number;
  public GaintCount: number;
  public OthersCount: number;
  public PVSCount: number;
  public RefractileCount: number;
  public SERCount: number; 
  public DLZCount: number; 
  public DPBCount: number; 
  public DPVSCount: number; 
  public DRKCCount: number; 
  public GPBCount: number; 
  public GRNLCCount: number; 
  public INCLBCount: number; 
  public LPVSCount: number; 
  public MCVCount: number; 
  public MICVCount: number; 
  public MPBCount: number; 
  public PCTPCount: number; 
  public SGCCount: number; 
  public SPBCount: number; 
  public SPTZCount: number; 
  public STCOLCount: number; 
  public THCKZCount: number;
  public THNZCount: number;

  public Sign1Name: string;
  //public Status: string;
  //public Morphology: string;
  //public RecordSts: string;
  public Date: Date;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  ScanDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;


  CurrentOocyteQualityAssessmentByCodeController: OocyteQualityAssessmentByCodeController[];
  Frozenlist: OocyteQualityAssessmentByCodeController[];
  TransferrableList: OocyteQualityAssessmentByCodeController[];
  DiscardedList: OocyteQualityAssessmentByCodeController[];
  AggList: OocyteQualityAssessmentByCodeController[];
  AZPList: OocyteQualityAssessmentByCodeController[];
  CGMList: OocyteQualityAssessmentByCodeController[];
  EGMList: OocyteQualityAssessmentByCodeController[];
  FPBList: OocyteQualityAssessmentByCodeController[];
  FragileList: OocyteQualityAssessmentByCodeController[];
  GaintList: OocyteQualityAssessmentByCodeController[];
  OthersList: OocyteQualityAssessmentByCodeController[];
  PVSList: OocyteQualityAssessmentByCodeController[];
  RefractileList: OocyteQualityAssessmentByCodeController[];
  SERList: OocyteQualityAssessmentByCodeController[];
  DLZList: OocyteQualityAssessmentByCodeController[]; 
  DPBList: OocyteQualityAssessmentByCodeController[]; 
  DPVSList: OocyteQualityAssessmentByCodeController[]; 
  DRKCList: OocyteQualityAssessmentByCodeController[]; 
  GPBList: OocyteQualityAssessmentByCodeController[]; 
  GRNLCList: OocyteQualityAssessmentByCodeController[]; 
  INCLBList: OocyteQualityAssessmentByCodeController[]; 
  LPVSList: OocyteQualityAssessmentByCodeController[]; 
  MCVList: OocyteQualityAssessmentByCodeController[]; 
  MICVList: OocyteQualityAssessmentByCodeController[]; 
  MPBList: OocyteQualityAssessmentByCodeController[]; 
  PCTPList: OocyteQualityAssessmentByCodeController[]; 
  SGCList: OocyteQualityAssessmentByCodeController[]; 
  SPBList: OocyteQualityAssessmentByCodeController[]; 
  SPTZList: OocyteQualityAssessmentByCodeController[]; 
  STCOLList: OocyteQualityAssessmentByCodeController[]; 
  THCKZList: OocyteQualityAssessmentByCodeController[];
  THNZList: OocyteQualityAssessmentByCodeController[];
  CurrentOocyteQualityAssessmentByCodeRequest: OocyteQualityAssessmentByCodeRequest;
  OocyteQualityCode: any;
  TreatmentCycleCode: any;
  ActorCode: any;

  LoadScansData() {

    this.CurrentOocyteQualityAssessmentByCodeRequest = new OocyteQualityAssessmentByCodeRequest();
    this.TreatmentCycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    this.CurrentOocyteQualityAssessmentByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetOocyteQualityAssessmentByCodeController();
  }


  GetOocyteQualityAssessmentByCodeController() {
    this.StartRefreshing();
    this.CurrentOocyteQualityAssessmentByCodeRequest.SingleWellFollicleCode = this.TreatmentCycleCode;

    this.actorservice.GetOocyteQualityAssessmentByCodeController(this.CurrentOocyteQualityAssessmentByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentOocyteQualityAssessmentByCodeController = this.ApiResData.Result;
          this.TotalCount = this.CurrentOocyteQualityAssessmentByCodeController.length;
          this.Frozenlist = this.ApiResData.Result;
          this.TransferrableList = this.ApiResData.Result;
          this.DiscardedList = this.ApiResData.Result;
          var list = this.Frozenlist.filter(
            function (a) {
              return a.IsFrozen == true
            });
          this.Frozenlist = list;
          this.FrozenCount = this.Frozenlist.length;
          var listTransferrable = this.TransferrableList.filter(
            function (b) {
              return b.IsContinue == true;
            });
          this.TransferrableList = listTransferrable;
          this.TransferedCount = this.TransferrableList.length;
          var listDiscarded = this.DiscardedList.filter(
            function (c) {
              return c.IsDiscarded == true;

            });
          this.DiscardedList = listDiscarded;
          this.DiscardedCount = this.DiscardedList.length;
          this.AggList = this.ApiResData.Result;
          this.AZPList = this.ApiResData.Result;
          this.CGMList = this.ApiResData.Result;
          this.EGMList = this.ApiResData.Result;
          this.FPBList = this.ApiResData.Result;
          this.FragileList = this.ApiResData.Result;
          this.GaintList = this.ApiResData.Result;
          this.OthersList = this.ApiResData.Result;
          this.PVSList = this.ApiResData.Result;
          this.RefractileList = this.ApiResData.Result;
          this.SERList = this.ApiResData.Result;
          this.DLZList = this.ApiResData.Result; 
          this.DPBList = this.ApiResData.Result; 
          this.DPVSList = this.ApiResData.Result; 
          this.DRKCList = this.ApiResData.Result; 
          this.GPBList = this.ApiResData.Result; 
          this.GRNLCList = this.ApiResData.Result; 
          this.INCLBList = this.ApiResData.Result; 
          this.LPVSList = this.ApiResData.Result; 
          this.MCVList = this.ApiResData.Result; 
          this.MICVList = this.ApiResData.Result; 
          this.MPBList = this.ApiResData.Result; 
          this.PCTPList = this.ApiResData.Result;
          this.SGCList = this.ApiResData.Result; 
          this.SPBList = this.ApiResData.Result; 
          this.SPTZList = this.ApiResData.Result; 
          this.STCOLList = this.ApiResData.Result; 
          this.THCKZList = this.ApiResData.Result;
          this.THNZList = this.ApiResData.Result;
          var list = this.AggList.filter(
            function (a) {
              return a.Morphology == "Aggregated"
            });
          this.AggList = list;
          this.AggregatedCount = this.AggList.length;
          var listAZP = this.AZPList.filter(
            function (b) {
              return b.Morphology == "AZP"
            });
          this.AZPList = listAZP;
          this.AZPCount = this.AZPList.length;
          var listCGM = this.CGMList.filter(
            function (c) {
              return c.Morphology == "CGM"

            });
          this.CGMList = listCGM;
          this.CGMCount = this.CGMList.length;
          var listEGM = this.EGMList.filter(
            function (d) {
              return d.Morphology == "EGM"
            });
          this.EGMList = listEGM;
          this.EGMCount = this.EGMList.length;
          var listFPB = this.FPBList.filter(
            function (e) {
              return e.Morphology == "FPB"

            });
          this.FPBList = listFPB;
          this.FPBCount = this.FPBList.length;
          var listFragile = this.FragileList.filter(
            function (f) {
              return f.Morphology == "Fragile Oolemma"

            });
          this.FragileList = listFragile;
          this.FragileCount = this.FragileList.length;
          var listGaint = this.GaintList.filter(
            function (g) {
              return g.Morphology == "Gaint Oocyte"

            });
          this.GaintList = listGaint;
          this.GaintCount = this.GaintList.length;
          var listOthers = this.OthersList.filter(
            function (h) {
              return h.Morphology == "Others"

            });
          this.OthersList = listOthers;
          this.OthersCount = this.OthersList.length;
          var listPVS = this.PVSList.filter(
            function (i) {
              return i.Morphology == "PVS"
            });
          this.PVSList = listPVS;
          this.PVSCount = this.PVSList.length;
          var listRefractile = this.RefractileList.filter(
            function (j) {
              return j.Morphology == "Refractile bodies"

            });
          this.RefractileList = listRefractile;
          this.RefractileCount = this.RefractileList.length;
          var listSER = this.SERList.filter(
            function (k) {
              return k.Morphology == "SER"

            });
          this.SERList = listSER;
          this.SERCount = this.SERList.length;
          var listDLZ = this.DLZList.filter(
            function (l) {
              return l.Morphology == "DLZ"

            });
          this.DLZList = listDLZ;
          this.DLZCount = this.DLZList.length;
          var listDPB = this.DPBList.filter(
            function (m) {
              return m.Morphology == "DPB"

            });
          this.DPBList = listDPB;
          this.DPBCount = this.DPBList.length;
          var listDPVS = this.DPVSList.filter(
            function (C) {
              return C.Morphology == "DPVS"

            });
          this.DPVSList = listDPVS;
          this.DPVSCount = this.DPVSList.length;
          var listDRKC = this.DRKCList.filter(
            function (n) {
              return n.Morphology == "DRKC"

            });
          this.DRKCList = listDRKC;
          this.DRKCCount = this.DRKCList.length;
          var listGPB = this.GPBList.filter(
            function (o) {
              return o.Morphology == "GPB"

            });
          this.GPBList = listGPB;
          this.GPBCount = this.GPBList.length;
          var listGRNLC = this.GRNLCList.filter(
            function (p) {
              return p.Morphology == "GRNLC"

            });
          this.GRNLCList = listGRNLC;
          this.GRNLCCount = this.GRNLCList.length;
          var listINCLB = this.INCLBList.filter(
            function (q) {
              return q.Morphology == "INCLB"

            });
          this.INCLBList = listINCLB;
          this.INCLBCount = this.INCLBList.length;
          var listLPVS = this.LPVSList.filter(
            function (r) {
              return r.Morphology == "LPVS"

            });
          this.LPVSList = listLPVS;
          this.LPVSCount = this.LPVSList.length;
          var listMCV = this.MCVList.filter(
            function (s) {
              return s.Morphology == "MCV"

            });
          this.MCVList = listMCV;
          this.MCVCount = this.MCVList.length;
          var listMICV = this.MICVList.filter(
            function (t) {
              return t.Morphology == "MICV"

            });
          this.MICVList = listMICV;
          this.MICVCount = this.MICVList.length;
          var listMPB = this.MPBList.filter(
            function (u) {
              return u.Morphology == "MPB"

            });
          this.MPBList = listMPB;
          this.MPBCount = this.MPBList.length;
          var listPCTP = this.PCTPList.filter(
            function (v) {
              return v.Morphology == "PCTP"

            });
          this.PCTPList = listPCTP;
          this.PCTPCount = this.PCTPList.length;
          var listSGC = this.SGCList.filter(
            function (w) {
              return w.Morphology == "SGC"

            });
          this.SGCList = listSGC;
          this.SGCCount = this.SGCList.length;
          var listSPB = this.SPBList.filter(
            function (x) {
              return x.Morphology == "SPB"

            });
          this.SPBList = listSPB;
          this.SPBCount = this.SPBList.length;
          var listSPTZ = this.SPTZList.filter(
            function (y) {
              return y.Morphology == "SPTZ"

            });
          this.SPTZList = listSPTZ;
          this.SPTZCount = this.SPTZList.length;
          var listSTCOL = this.STCOLList.filter(
            function (z) {
              return z.Morphology == "STCOL"

            });
          this.STCOLList = listSTCOL;
          this.STCOLCount = this.STCOLList.length;
          var listTHCKZ = this.THCKZList.filter(
            function (A) {
              return A.Morphology == "THCKZ"

            });
          this.THCKZList = listTHCKZ;
          this.THCKZCount = this.THCKZList.length;
          var listTHNZ = this.THNZList.filter(
            function (B) {
              return B.Morphology == "THNZ"

            });
          this.THNZList = listTHNZ;
          this.THNZCount = this.THNZList.length;

          this.stopRefreshing();
          this.LoadOqaData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  CurrentIvfOocyteEmbryoStorageByCodeController: Array<IvfOocyteEmbryoStorageByCodeController>;
  CurrentIvfOocyteEmbryoStorageByCodeRequest: IvfOocyteEmbryoStorageByCodeRequest;
  OocyteStorageDetails: IvfOocyteEmbryoStorageByCodeController;
  LoadOqaData() {
    //alert("ScansData")
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest = new IvfOocyteEmbryoStorageByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.TreatmentCycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    this.ActorCode = this.route.snapshot.paramMap.get('ActorCodedata');
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfOocyteEmbryoStorageByCodeController();
  }

  GetIvfOocyteEmbryoStorageByCodeController() {
    this.StartRefreshing();

    //this.CurrentIvfOocyteEmbryoStorageByCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ActorCode = this.SelectedpatientDetails.EggSourceActorCode;
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.TreatmentCycle = this.TreatmentCycleCode;
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ActorCode = this.ActorCode;
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ConditionalOperator = 10;

    //alert(this.FormattedCode);
    this.actorservice.GetIvfOocyteEmbryoStorageByCodeController(this.CurrentIvfOocyteEmbryoStorageByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfOocyteEmbryoStorageByCodeController = this.ApiResData.Result;

          if (this.CurrentIvfOocyteEmbryoStorageByCodeController != null ||
            this.CurrentIvfOocyteEmbryoStorageByCodeController.length > 0) {

            this.OocyteStoreItems = new Array<OocyteStoreItem>();
            this.CurrentIvfOocyteEmbryoStorageByCodeController.forEach((v, i, d) => {
              var item = new OocyteStoreItem();
              item.IsSelected = false;
              item.Morphology = v.Morphology;
              item.OocyteEmbryoStorageCode = v.OocyteEmbryoStorageCode;
              item.Status = v.Status;
              item.StorageUnitType = v.StorageUnitType;
              item.StorageUnitDetails = v.StorageUnitDetails;
              item.WellNo = v.WellNo;
              this.OocyteStoreItems.push(item);
            });

          }

          //this.OocyteQADetails = this.CurrentOocyteQualityAssessmentByCodeController[0];
          //this.CurrentOocyteQualityAssessmentByCodeController = new Array<OocyteQualityAssessmentByCodeController>();
          //var data = this.ApiResData.Result as Array<OocyteQualityAssessmentByCodeController>;

          //data.forEach((v, i, a) => {
          //    this.CurrentOocyteQualityAssessmentByCodeController.push(v);
          //});
          //for (let index = 0; index < data.length; index++){
          //    //alert(data[index].SingleWellFollicleCoder);

          //    this.CurrentOocyteQualityAssessmentByCodeController.push(data[index]);
          //}
          //    this.FollicularOocyteInfo = this.CurrentOocyteQualityAssessmentByCodeController[0];
          //   alert(this.FollicularOocyteInfo.TreatmentCycle);
          //if (this.FollicularScanEndInfo.ScanDate != null) {
          //  var SValidFrom = new Date(this.FollicularScanEndInfo.ScanDate);
          //  if (SValidFrom.getFullYear() > 1900) {
          //    console.log('this.UpdateDate >1990');
          //    this.ScanDate = {

          //      year: SValidFrom.getFullYear(),
          //      month: SValidFrom.getMonth() + 1,
          //      day: SValidFrom.getDate()
          //    }
          //  }
          //}
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          this.LoadPatients();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  OocyteStoreItems: Array<OocyteStoreItem>;
  Store() {
    //alert(new);
    var toFreeze = this.CurrentOocyteQualityAssessmentByCodeController.filter(function (v, i, d) {
      return v.IsFrozen == true
    });

    if (this.CurrentIvfOocyteEmbryoStorageByCodeController == null ||
      this.CurrentIvfOocyteEmbryoStorageByCodeController.length == 0) {

      this.OocyteStoreItems = new Array<OocyteStoreItem>();
      toFreeze.forEach((v, i, d) => {
        var item = new OocyteStoreItem();
        item.IsSelected = false;
        item.Morphology = v.Morphology;
        item.OocyteEmbryoStorageCode = 0;
        item.WellNo = v.WellNo;
        this.OocyteStoreItems.push(item);
      });

    }
  }

  CurrentCycleOocyteQualityBetweenDateController: CycleOocyteQualityBetweenDateController[];
  CurrentCycleOocyteQualityBetweenDateRequest: CycleOocyteQualityBetweenDateRequest;
  LoadPatients() {
    this.CurrentCycleOocyteQualityBetweenDateRequest = new CycleOocyteQualityBetweenDateRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentCycleOocyteQualityBetweenDateRequest.FacilityCode = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
    this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;
    this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date(2017, 1, 1);// "1-JAN-2017";
    this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();// "31-DEC-2018";
    //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentCycleOocyteQualityBetweenDateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetCycleOocyteQualityBetweenDateController();
  }

  GetCycleOocyteQualityBetweenDateController() {
    this.StartRefreshing();


    this.actorservice.GetCycleOocyteQualityBetweenDateController(this.CurrentCycleOocyteQualityBetweenDateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCycleOocyteQualityBetweenDateController = this.ApiResData.Result;
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          this.printService.onDataReady();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

    public printService: PrintService) {


  }


  ngOnInit() {
    //alert("in scans comp");
    this.Date = new Date();

    this.Owner = this.route.snapshot.paramMap.get('Owner');
    this.PatientId = this.route.snapshot.paramMap.get('PatientId');
    this.ProtocolStart = this.route.snapshot.paramMap.get('ProtocolStart');
    this.ProtocolEnd = this.route.snapshot.paramMap.get('ProtocolEnd');
    this.Protocol = this.route.snapshot.paramMap.get('Protocol');
    this.Infertility = this.route.snapshot.paramMap.get('Infertility');
    this.Gender = this.route.snapshot.paramMap.get('Gender');
    this.Age = this.route.snapshot.paramMap.get('Age');
    this.CycleNo = this.route.snapshot.paramMap.get('CycleNo');
    this.CycleType = this.route.snapshot.paramMap.get('CycleType');
    this.Sign1Name = this.route.snapshot.paramMap.get('Sign1Name');
    //this.Storage = this.route.snapshot.paramMap.get('Storage');
    //this.Status = this.route.snapshot.paramMap.get('Status');
    //this.Morphology = this.route.snapshot.paramMap.get('Morphology');
    this.LoadScansData();


  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}








